let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iI1rx")).then(() => parcelRequire('7Xamg'));